module.exports = __webpack_public_path__ + "static/media/tag.b85c9c67.mp4";